export default "__VITE_ASSET__56f226de__"